<div class="not-found-container">
    <div class="text-center">
        <h1 class="display-1 fw-bold">404</h1>
        <h2 class="fs-1 mb-4">{{ 'notFound.title' | translate }}</h2>
        <p class="fs-5 text-muted mb-5">{{ 'notFound.message' | translate }}</p>
        <a routerLink="/" class="btn btn-primary btn-lg">
            <i class="bi bi-house-door me-2"></i>
            {{ 'notFound.backHome' | translate }}
        </a>
    </div>
</div>